<template>
    <div>
        <v-app-bar :color="appBarColor" style="opacity: 0.9;" flat fixed v-scroll="onScrollHeaderHandler">
            <div class="header-menu-icon">
                <v-app-bar-nav-icon @click="drawer = true" class="white--text" />
            </div>
            <v-container>
                <div class="tway-header d-flex">
                    <div class="tway-header-logo">
                        <router-link :to="{ name: 'home' }" exact>
                            <v-img alt="Tway logo" class="shrink" contain :src="require('@/assets/images/logo/tway-logotipo-gris.svg')" max-height="45" min-width="100" width="128" />
                        </router-link>
                    </div>
                    <v-spacer />
                    <div class="tway-header-menu">
                        <router-link :to="{ name: 'platform' }">
                            Plataforma
                        </router-link>
                        <router-link :to="{ name: 'plans' }">
                            Planes
                        </router-link>
                        <router-link :to="{ name: 'trends' }">
                            Tendencias
                        </router-link>
                        <router-link :to="{ name: 'help' }">
                            ¿Qué es Tway?
                        </router-link>
                        <router-link :to="{ name: 'team' }">
                            Equipo
                        </router-link>
                        <a href="#" @click="$vuetify.goTo('footer', scrollFooterOptions)">
                            Contacto
                        </a>
                        <v-btn rounded color="white" class="white--text font-weight-bold" :href="config.login" :outlined="true">
                            Inicia sesión
                        </v-btn>
                        <v-btn rounded :href="config.signup" color="tway-verde-manzana" class="white--text font-weight-bold">
                            REGÍSTRATE GRATIS
                        </v-btn>
                    </div>
                </div>
            </v-container>
        </v-app-bar>
        <v-navigation-drawer v-model="drawer" fixed temporary>
            <v-list nav dense>
                <v-list-item-group exact-active-class="tway-morado--text" class="tway-morado--text">
                    <div class="colunm-flex">
                        <router-link :to="{ name: 'home' }" exact>
                            <v-img alt="Tway logo" class="shrink mb-8" contain :src="require('@/assets/images/logo/logo.svg')" max-height="40" min-width="100" width="100" />
                        </router-link>
                        <v-btn outlined @click="drawer = false" style="border: 1px solid transparent !important;" elevation="0">
                            <v-img alt="Tway logo" class="shrink mb-8 pr-0" :src="require('@/assets/images/logo/logo-closed.svg')" max-height="20" min-width="20" width="20" />
                        </v-btn>
                    </div>
                    <v-list-item :to="{ name: 'home' }" exact :class="$route.name == 'home' ? 'selected' : ''">
                        <v-list-item-content class="not-selected">
                            Inicio
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item :to="{ name: 'platform' }" exact :class="$route.name == 'platform' ? 'selected' : ''">
                        <v-list-item-content class="not-selected">
                            Plataforma
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item :to="{ name: 'team' }" exact :class="$route.name == 'team' ? 'selected' : ''">
                        <v-list-item-content class="not-selected">
                            Equipo
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item :to="{ name: 'plans' }" :class="$route.name == 'plans' ? 'selected' : ''" exact>
                        <v-list-item-content class="not-selected">
                            Planes
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item :to="{ name: 'trends' }" exact :class="$route.name == 'trends' ? 'selected' : ''">
                        <v-list-item-content class="not-selected">
                            Tendencias
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item :to="{ name: 'help' }" exact :class="$route.name == 'help' ? 'selected' : ''">
                        <v-list-item-content class="not-selected">
                            ¿Qué es Tway?
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item @click="$vuetify.goTo('footer', scrollFooterOptions)" exact :class="$route.name == 'help' ? 'selected' : ''">
                        <v-list-item-content class="not-selected">
                            Contacto
                        </v-list-item-content>
                    </v-list-item>
                    <v-row justify="center" class="px-5 py-1">
                        <v-btn rounded width="100%" :href="config.signup" color="tway-verde-manzana" class="white--text font-weight-bold">
                            REGÍSTRATE GRATIS
                        </v-btn>
                    </v-row>
                    <v-row justify="center" class="px-5 py-1">
                        <v-btn rounded color="tway-morado" width="100%" class="white--text font-weight-bold" :href="config.login" :outlined="true">
                            Inicia sesión
                        </v-btn>
                    </v-row>
                </v-list-item-group>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>
<script>
export default {
    name: 'Header',

    data: () => ({
        appBarColor: 'transparent',
        drawer: false,
        config: {}
    }),
    methods: {
        onScrollHeaderHandler(e) {
            this.appBarColor = e.target.scrollingElement.scrollTop > 0 ? 'tway-violeta' : 'transparent';
        }
    },
    created: function() {
        this.config.login = process.env.VUE_APP_LOGIN;
        this.config.signup = process.env.VUE_APP_SIGNUP;
    },
    computed: {
        scrollFooterOptions () {
            return {
                duration: 500,
                offset: 0,
                easing: 'linear',
            }
      },
    },
};
</script>
<style>
.tway-header-menu {
    display: flex;
}

.selected {
    background: #DCC5F4;
    color: #7319D5 !important;
}

.not-selected {
    color: #7319D5 !important;
}

.tway-header-menu a {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    color: #ffffff !important;
    align-self: center;
    margin-left: 15px;
    margin-right: 15px;
    text-decoration: none;
}

/* Override active vue router */
.tway-header-menu .router-link-active {
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.65);
    padding: 10px 15px;
    margin-left: 0px;
    margin-right: 0px;
    color: #4a148c !important;
}

.colunm-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.header-menu-icon {
    display: none;
}

@media(max-width: 960px) {
    .header-menu-icon {
        display: initial;
    }

    .tway-header-menu {
        display: none;
    }
}
</style>